var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.652111 15.7323C0.741945 15.5153 0.894113 15.3299 1.08937 15.1993C1.28462 15.0688 1.5142 14.9991 1.74906 14.9991L7.68656 14.9991L7.68656 3.12407C7.68656 2.49418 7.93679 1.89009 8.38219 1.44469C8.82759 0.99929 9.43168 0.749067 10.0616 0.749067L21.9366 0.749068C22.5665 0.749068 23.1705 0.999292 23.6159 1.44469C24.0613 1.89009 24.3116 2.49418 24.3116 3.12407L24.3116 14.9991L30.2491 14.9991C30.4841 14.9989 30.7138 15.0684 30.9093 15.1989C31.1048 15.3294 31.2571 15.5149 31.3471 15.732C31.437 15.9491 31.4605 16.188 31.4146 16.4185C31.3687 16.649 31.2555 16.8606 31.0892 17.0267L16.8392 31.2767C16.7289 31.3871 16.598 31.4747 16.4538 31.5345C16.3096 31.5942 16.1551 31.625 15.9991 31.625C15.843 31.625 15.6885 31.5942 15.5443 31.5345C15.4002 31.4747 15.2692 31.3871 15.1589 31.2767L0.908906 17.0267C0.742885 16.8606 0.629873 16.6489 0.584163 16.4185C0.538453 16.1881 0.562099 15.9493 0.652111 15.7323Z",
    fill: "#3851C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternBlueArrow);
export default __webpack_public_path__ + "static/media/patternBlueArrow.00e42315ef0b945d493b0fbdf42b9303.svg";
export { ForwardRef as ReactComponent };